module.exports = __webpack_public_path__ + "img/leg-management.1e8c9f45.svg";